import { productFromFirestore } from '@parallel-fluidics/shared/models/products';
import {
  doc,
  getDoc,
  getFirestore,
} from 'firebase/firestore';

export default async function fetchProduct(productDocId) {
  const snapshot = await getDoc(doc(getFirestore(), 'products', productDocId));

  if (!snapshot.exists()) {
    throw new Error(`Product not found: ${productDocId}`);
  }

  return productFromFirestore(snapshot);
}
